import type { FC } from "react";
import { EditableAmountRow } from "web_myplann/Finances/Components/EditableAmountRow";
import type { IncomeFormEntry } from "web_myplann/Finances/Forms/useIncomeV2Form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

type Props = {
	items: IncomeFormEntry[];
	rowKeys: string[];
	onEdit: (index: number) => void;
	onRemove: (index: number) => void;
};

export const IncomeRowList: FC<Props> = ({
	items,
	rowKeys,
	onEdit,
	onRemove,
}) => {
	const { t } = useResource();
	const currencySign = t(Resources.Common.CurrencySign);

	return (
		<>
			{items.map((income, index) => (
				<EditableAmountRow
					key={rowKeys[index]}
					title={income.name}
					subtitle={moneyFormatter(income.amount, currencySign)}
					onEdit={() => onEdit(index)}
					onRemove={() => onRemove(index)}
				/>
			))}
		</>
	);
};
